import {ApiFindOptions, useApiFind} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import { PATH as ROSTER_PATH } from '../const';
import {StubbornService} from "../../../../../application/business/StubbornAsset";

export const useRosterServiceContextFind = (options: ApiFindOptions = {}) => useApiFind<Pick<StubbornService, 'name' | 'description' | 'parameters' | 'type'>>(`${ROSTER_PATH}${PATH}`, options);
